/*
 * "Next refresh in m:ss" line (PROD-9977). Owns the 1s ticker so only this span re-renders.
 */
import React, { useEffect, useState } from 'react';
import { countdownLabel } from './my_leads';

const TICK_MS = 1000;

interface Props {
  // Client time the server cache expires (see refreshDueAt); null = unknown.
  dueAt: number | null;
  loading?: boolean;
}

function RefreshCountdown({ dueAt, loading }: Props) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(id);
  }, []);
  return <span>{loading ? 'Refreshing…' : countdownLabel(dueAt, now)}</span>;
}

export default RefreshCountdown;
